export const config = {
  id: 'perchEnergy',
  path: '/perch-energy',
  show: () => false,
};
